import React, { useState, useEffect } from "react";
import { TextInput, Divider, Switch } from "@mantine/core";
import { shallow } from "zustand/shallow";
import { useTranslation } from "react-i18next";
import useAppStore from "./effort-settings-store";

export default function GeneralSettings({ onUpdate, isVehicleDataEffort }) {
  const { t } = useTranslation();
  const { settings, setSettings } = useAppStore(
    (state) => ({
      settings: state.settings,
      setSettings: state.setSettings,
    }),
    shallow
  );

  const [tempSettings, setTempSettings] = useState({
    member_rebound_message: settings.member_rebound_message,
    non_member_rebound_message: settings.non_member_rebound_message,
  });

  useEffect(() => {
    setTempSettings({
      member_rebound_message: settings.member_rebound_message,
      non_member_rebound_message: settings.non_member_rebound_message,
    });
  }, [JSON.stringify(settings)]);

  const textFields = [
    {
      name: "member_rebound_message",
      label: t("mixer:effort:member_rebound_message_title"),
    },
    {
      name: "non_member_rebound_message",
      label: t("mixer:effort:non_member_rebound_message_title"),
    },
  ];

  return (
    <div>
      {textFields.map((m, i) => (
        <TextInput
          key={i}
          label={m.label}
          value={tempSettings[m.name]}
          onChange={(e) => {
            if (e.target.value.length > 160) return;
            // onUpdate({ [m.name]: e.target.value });
            setTempSettings({ ...tempSettings, [m.name]: e.target.value });
          }}
          onBlur={(e) => onUpdate({ [m.name]: e.target.value })}
          max={160}
        />
      ))}
      {/* {isVehicleDataEffort && (
        <>
          <Divider my="lg" />
          <Switch
            label="Loyalty Membership Required"
            description="Require users to be a member of the loyalty program to enter the effort"
            checked={settings.require_membership || false}
            onChange={(e) =>
              onUpdate({
                ...tempSettings,
                require_membership: !settings.require_membership || false,
              })
            }
          />
        </>
      )} */}
    </div>
  );
}
